import React from "react";
export const ProductContext = React.createContext({});
ProductContext.displayName = "ProductContext";
export const ProductProvider = ({ children, product, storeProduct }) => (React.createElement(ProductContext.Provider, { value: { ...product, storeId: storeProduct.id, storeProduct } }, children));
//# sourceMappingURL=provider.js.map